import Joi from 'joi';

export const similarItemsSettingsValidationSchema = {
  numberOfResultsToDisplay: Joi.number().required().min(3).max(20),
  addToCart: Joi.object({ active: Joi.boolean() }),
  enableTextSimilarity: Joi.bool().required(),
};
